module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_j_normal.d8c5668b.png";